import { ProgressSpinner } from 'primereact/progressspinner';

export const ToolkitLoader = () => (
  <div className="flex h-32 flex-col items-center justify-center gap-4">
    <ProgressSpinner style={{ width: '48px', height: '48px' }} strokeWidth="4" animationDuration="1.5s" />
    <div
      className="text-lg font-medium"
      style={{
        background: 'linear-gradient(331deg,#12403a 12.5%, #2FA696 81.38%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}
    >
      Loading toolkit...
    </div>
  </div>
);
